import apiCommon from '@/api/ecommerce/common';

const defaultState = () => ({
	optionBank: [],
	optionProduct: [],
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {

};

const mutations = {
	setOptionBank(state, data) {
		state.optionBank = data
	},
	setOptionProduct(state, data) {
		state.optionProduct = data
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataStockist(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getOptionBank({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiCommon.optionBank(params).then(({ data: { data } }) => {
				commit('setOptionBank', data.results);
				resolve(data.results)
			}).catch((err) => {
				commit('setOptionBank', []);
				const data = err.response.data
				dispatch("errorHandler", data)
				reject()
			});
		})
	},
	getOptionProduct({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiCommon.optionProduct(params).then(({ data: { data } }) => {
				commit('setOptionProduct', data.results);
				resolve(data.results)
			}).catch((err) => {
				commit('setOptionProduct', []);
				const data = err.response.data
				dispatch("errorHandler", data)
				reject()
			});
		})
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.message
			}, { root: true });
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};